import { Validation } from '@singularsystems/neo-core';
import BankDetail from '../ValueObjects/BankDetail';
import TemporalEntity from '../TemporalEntity';

export default class InvestorBankDetail extends TemporalEntity {

    constructor() {
        super();
        this.makeObservable();
    }

    public investorBankDetailId: number = 0;

    public investorId: number = 0;

    public values: BankDetail = new BankDetail();

    // Client only properties / methods

    protected addBusinessRules(rules: Validation.Rules<this>) {
        super.addBusinessRules(rules);
    }

    public toString(): string {
        if (this.isNew) {
            return "New investor bank detail";
        } else {
            return "Investor Bank Detail";
        }
    }
}